<template>
    <div v-if="appParams && appParams.staticTranslations">
        <div class="container">
            <h2 style="margin-top: 3.5rem">{{ realization.title }}</h2>
            <p
                class="itb-bigger-p"
                style="margin: 2.1rem 0 2.5rem"
                v-html="realization.description"
            ></p>
        </div>

        <section class="itb-references-alike-set">
            <div class="container">
                <div class="row position-relative">
                    <div class="col-12 col-sm-6">
                        <div
                            class="card itb-big-card w-100 itb-margin-bottom itb-lazy-loading-bg"
                            v-lazy:background-image="
                                realization.imageBefore
                                    ? '/uploads/' +
                                      realization.imageBefore.path +
                                      '/' +
                                      realization.imageBefore.name
                                    : null
                            "
                        >
                            <div class="card-body d-flex p-0">
                                <div
                                    class="itb-text w-100"
                                    :class="
                                        isResponsive
                                            ? 'align-self-start'
                                            : 'align-self-end'
                                    "
                                >
                                    <h3 class="mb-0">
                                        {{
                                            appParams.staticTranslations[
                                                "realizations.before_implementation"
                                            ]
                                        }}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="itb-helmet">
                        <img
                            src="/images/articles/helmet.webp"
                            alt="Před VS Po ikonka"
                        />
                    </div>

                    <div class="col-12 col-sm-6">
                        <div
                            class="card itb-big-card w-100 itb-margin-bottom itb-lazy-loading-bg"
                            v-lazy:background-image="
                                realization.imageAfter
                                    ? '/uploads/' +
                                      realization.imageAfter.path +
                                      '/' +
                                      realization.imageAfter.name
                                    : null
                            "
                        >
                            <div class="card-body d-flex p-0">
                                <div class="itb-text align-self-end w-100">
                                    <h3 class="mb-0">
                                        {{
                                            appParams.staticTranslations[
                                                "realizations.after_implementation"
                                            ]
                                        }}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <Tinybox
                        v-model="index"
                        :images="realization.gallery ? realization.gallery : []"
                    ></Tinybox>

                    <div
                        class="col-12 col-md-4"
                        v-for="(image, idx) in realization.gallery"
                        :key="idx"
                    >
                        <div
                            class="card w-100 itb-margin-bottom itb-lazy-loading-bg open-tinybox"
                            @click="index = idx"
                            v-lazy:background-image="
                                image
                                    ? '/uploads/' +
                                      image.path +
                                      '/' +
                                      'sm_' +
                                      image.name
                                    : null
                            "
                            :title="image.description"
                        >
                            <div class="card-body d-flex p-0">
                                <div
                                    v-if="image.description"
                                    class="itb-text align-self-end w-100"
                                    style="padding: 1rem 0"
                                >
                                    <h4 class="mb-0">
                                        {{ image.description }}
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div class="container d-flex" style="margin-bottom: 3.75rem">
            <router-link
                v-if="prevRealization"
                :to="{
                    name: commonRouteName,
                    params: {
                        categoryAlias: prevRealization.categoryAlias,
                        realizationAlias:
                            prevRealization.id + '-' + prevRealization.alias,
                    },
                }"
                class="btn btn-primary itb-btn-icon mt-0"
            >
                <img
                    src="/images/icons/4soft_icon_angle-left.svg"
                    :alt="
                        appParams.staticTranslations['general.button'] +
                        ' ' +
                        appParams.staticTranslations['realizations.show_prev']
                    "
                    class="itb-icon itb-angle-left-icon"
                />
                {{ appParams.staticTranslations["realizations.show_prev"] }}
            </router-link>

            <router-link
                v-if="nextRealization"
                :to="{
                    name: commonRouteName,
                    params: {
                        categoryAlias: nextRealization.categoryAlias,
                        realizationAlias:
                            nextRealization.id + '-' + nextRealization.alias,
                        scrollToElementId: 'itb-breadcrumbs',
                    },
                }"
                class="btn btn-primary itb-btn-icon mt-0 ml-auto"
            >
                {{ appParams.staticTranslations["realizations.show_next"] }}
                <img
                    src="/images/icons/4soft_icon_angle-right.svg"
                    :alt="
                        appParams.staticTranslations['general.button'] +
                        ' ' +
                        appParams.staticTranslations['realizations.show_next']
                    "
                    class="itb-icon itb-angle-right-icon"
                />
            </router-link>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Tinybox from "vue-tinybox";

export default {
    data() {
        return {
            index: null,
            pageParams: [],
            realization: [],
            prevRealization: null,
            nextRealization: null,
            isResponsive: false,
        };
    },

    components: {
        Tinybox,
    },

    watch: {
        "$route.params.realizationAlias": function (id) {
            this.getPageData();
        },
    },

    created() {
        this.onResize();
        window.addEventListener("resize", this.onResize);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },

    mounted() {
        this.getPageData();
    },

    computed: {
        ...mapGetters({
            appParams: "getAppParams",
        }),

        commonRouteName: function () {
            var categoryAlias = "";

            if (this.$route.path.includes("other-products-realizations")) {
                categoryAlias = this.$route.path.split("/")[2];
            } else {
                categoryAlias = this.$route.path.split("/")[1];
            }

            if (categoryAlias == "2d-products") {
                return "realizationDetail2D";
            } else if (categoryAlias == "3d-products") {
                return "realizationDetail3D";
            } else {
                return "realizationDetailOtherProducts";
            }
        },
    },

    methods: {
        ...mapActions(["setPageParams"]),

        async getPageData() {
            var categoryAlias = "";

            if (this.$route.path.includes("other-products-realizations")) {
                categoryAlias = this.$route.path.split("/")[2];
            } else {
                categoryAlias = this.$route.path.split("/")[1];
            }

            axios
                .get(
                    `/getRealizationDetailPage/${categoryAlias}/${
                        this.$route.params.realizationAlias.split("-")[0]
                    }`
                )
                .then((response) => {
                    this.pageParams = response.data.params;
                    this.realization = response.data.realization;
                    this.prevRealization = response.data.prevRealization;
                    this.nextRealization = response.data.nextRealization;
                    this.setPageParams(this.pageParams);
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        onResize() {
            if (window.innerWidth < 576) {
                this.isResponsive = true;
            } else {
                this.isResponsive = false;
            }
        },
    },
};
</script>
